var path = 'app/scripts/modules/kubernetes/src/pipeline/stages/resizeAsg/resizeStepLabel.html';
var html = "<span class=\"task-label\">\n  Resize Server Group:\n  {{step.context.serverGroupName}}\n  ({{step.context.namespace}})\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/pipeline/stages/resizeAsg/resizeStepLabel.html
// module id = 1498
// module chunks = 0